{
  "de": {
    "partner": {
      "actions": {
        "activate": "Aktivieren",
        "add": "Hinzufügen",
        "changeProfilePicture": "Profilbild ändern",
        "deactivate": "Deaktivieren",
        "new": "Partner",
        "profilePictureFormat": "Sollte mindestens 300×300 px sein",
        "save": "Speichern",
        "sendinvitation": "Einladung senden",
        "submit": "Speichern",
        "undoChanges": "Rückgängig machen"
      },
      "attributes": {
        "email_address": "E-Mail",
        "email_notifications_interval": {
          "daily": "Einmal täglich (gegen Mittag)",
          "hourly": "Stündlich",
          "twice_daily": "Zweimal täglich (Morgen/Mittag)",
          "weekly": "Einmal wöchentlich (montags mittags)"
        },
        "first_name": "Vorname",
        "internal_note": "Interne Notiz",
        "language": "Sprache",
        "last_name": "Nachname",
        "phone_landline": "Festnetznummer",
        "phone_mobile": "Mobilnummer",
        "profession": "Position",
        "session_ended_at": "Zuletzt aktiv am",
        "status": "Status",
        "title": "Anrede"
      },
      "labels": {
        "activate_message": "{name} erhält wieder Zugriff auf die Plattform.",
        "addExistingCompany": "Zu bestehender Organisation hinzufügen",
        "contactDetails": "Kontaktdaten",
        "createNewCompany": "Neue Organisation erstellen",
        "deactivate_message": "{name} behält das Konto, verliert aber den Zugriff auf die Plattform. Nachrichten, Dokumente und der Name bleiben erhalten.",
        "information": "Profilinformationen",
        "newTeamMember": "Neuer Partner",
        "notEditable": "Einige Eingabefelder sind nicht mehr bearbeitbar, sobald ein Partner aktiv ist",
        "partnerAddedState": "<b>Noch nicht eingeladen</b>. Eine Einladungs-E-Mail wird gesendet, sobald {partner_name} Zugriff auf eine veröffentlichte Entscheidung, einen Punkt oder ein Dokument erhält.",
        "selectedCompany": "Ausgewählte Organisation",
        "start_by_selecting_project": "Beginnen Sie, indem Sie links ein Projekt auswählen"
      },
      "toasts": {
        "create": "Partner erstellt",
        "update": "Partner aktualisiert"
      },
      "validation": {
        "mustBeEmailAddress": "Gültige E-Mail-Adresse erforderlich",
        "needFirstName": "Vorname erforderlich",
        "needLastName": "Nachname erforderlich",
        "requireEmailAddress": "E-Mail-Adresse erforderlich"
      }
    }
  }
}
